/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { useSubscription } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { setSymbolAction, setForecastHorizonAction, setModelIdAction } from '../redux/symbols/actionCreator';
import { setAllProductAction, setSelectedProductAction } from '../redux/products/actionCreator';
import { SYMBOL_BY_USER_WITH_STATUS } from '../graphql-query/graphql-query';
import { setDailogStatusAction } from '../redux/pricingLayoutDailog/actionCreator';
import { setAllSymbolAction } from '../redux/allSymbols/actionCreator';

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu, events }) => {
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );
  const dispatch = useDispatch();
  const symbolDropdown = useSubscription(SYMBOL_BY_USER_WITH_STATUS);

  const onSelectingSymbol = (symbolObj, selectedForecastHorizon) => {
    dispatch(setSymbolAction(symbolObj));
    dispatch(setModelIdAction(symbolObj.models[0].id));
    dispatch(setForecastHorizonAction(selectedForecastHorizon));
  };

  const selectProduct = (productName, manualSwitched) => {
    dispatch(setSelectedProductAction(productName));
    if (manualSwitched) {
      const symbolsForUser = symbolDropdown.data.core_user[0].user_symbols
        .filter(y => y.status !== 'canceled' && y.status !== 'incomplete_expired')
        .filter(z => z.symbol.web_product_symbol_mappings[0].product.product_name === productName)[0];
      onSelectingSymbol(symbolsForUser.symbol, symbolsForUser.symbol.forecast_horizon_list[0].forecast_horizon);
    }
  };

  useEffect(() => {
    if (symbolDropdown.loading === false && symbolDropdown.data !== undefined && symbolDropdown.data != null) {
      if (symbolDropdown.data.core_user[0].user_symbols.length > 0) {
        const uniqueProductName = symbolDropdown.data.core_user[0].user_symbols
          .map(s => s.symbol.web_product_symbol_mappings[0].product.product_name)
          .filter((value, index, array) => array.indexOf(value) === index);

        dispatch(setAllProductAction(uniqueProductName));
        selectProduct(uniqueProductName[0]);
        dispatch(setAllSymbolAction(symbolDropdown.data.core_user[0].user_symbols));
        onSelectingSymbol(
          symbolDropdown.data.core_user[0].user_symbols[0].symbol,
          symbolDropdown.data.core_user[0].user_symbols[0].symbol.forecast_horizon_list[0].forecast_horizon,
        );
      } else if (
        symbolDropdown.data.core_user[0].user_symbols.allSymbol &&
        symbolDropdown.data.core_user[0].user_symbols.allSymbol.length === 0
      ) {
        dispatch(setDailogStatusAction(true));
      }
    }
  }, [symbolDropdown.loading, symbolDropdown.data]);

  const getProductData = () => {
    if (symbolDropdown.loading === false && symbolDropdown.data !== undefined && symbolDropdown.data != null) {
      const productForUser = symbolDropdown.data.core_user[0].user_symbols;
      const uniqueProductName = productForUser
        .map(s => s.symbol.web_product_symbol_mappings[0].product.product_name)
        .filter((value, index, array) => array.indexOf(value) === index);
      return uniqueProductName.map(productName => (
        <Menu.Item key={productName} icon={!topMenu && <FeatherIcon icon="home" />}>
          <NavLink
            onClick={() => {
              toggleCollapsed();
              selectProduct(productName, true);
            }}
            to="#"
            style={{ textTransform: 'Capitalize' }}
          >
            {productName}
          </NavLink>
        </Menu.Item>
      ));
    }
    return null;
  };

  const onOpenChange = keys => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = item => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      {getProductData()}
    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object,
};

export default MenuItems;
